var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5706_4258",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5706_4258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 39.513C14.1111 39.513 11.9444 38.526 10.1667 36.5519C8.38889 34.5779 7.5 32.1721 7.5 29.3344V9.9026C7.5 7.86688 8.15278 6.12419 9.45833 4.67451C10.7639 3.22484 12.3333 2.5 14.1667 2.5C16 2.5 17.5694 3.22484 18.875 4.67451C20.1806 6.12419 20.8333 7.86688 20.8333 9.9026V24.7078H18.3333V9.9026C18.3333 8.60714 17.9306 7.51218 17.125 6.61769C16.3194 5.72321 15.3333 5.27597 14.1667 5.27597C13 5.27597 12.0139 5.72321 11.2083 6.61769C10.4028 7.51218 10 8.60714 10 9.9026V29.3344C10 31.3701 10.6528 33.1128 11.9583 34.5625C13.2639 36.0122 14.8333 36.737 16.6667 36.737C17.4722 36.737 18.2292 36.5905 18.9375 36.2975C19.6458 36.0045 20.2778 35.5958 20.8333 35.0714V38.4026C20.1944 38.7419 19.5278 39.0118 18.8333 39.2123C18.1389 39.4127 17.4167 39.513 16.6667 39.513ZM24.1667 37.6623V32.1104H19.1667V28.4091H24.1667V22.8571H27.5V28.4091H32.5V32.1104H27.5V37.6623H24.1667ZM16.6667 29.3344V32.1104C15.5 32.1104 14.5139 31.6631 13.7083 30.7687C12.9028 29.8742 12.5 28.7792 12.5 27.4838V9.9026H15V27.4838C15 28.0081 15.1597 28.4476 15.4792 28.8024C15.7986 29.1571 16.1944 29.3344 16.6667 29.3344ZM23.3333 19.1558V9.9026H25.8333V19.1558H23.3333Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/File_Upload.3e8ae57acf35f0a159e0dc3221a1df8d.svg";
export { ForwardRef as ReactComponent };